var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cheese_footer fix_footer"},[_c('div',{staticClass:"new-btn",on:{"click":_vm.add}},[_c('van-icon',{staticStyle:{"line-height":"1rem"},attrs:{"name":"plus"}}),_vm._v("新建")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }